define.alias("ember-tooltips/components/ember-tooltip", "settings/components/ember-tooltip");